import { FONT_FAMILY } from '@web/styles/typography'

const themeStyles = colors => {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    clickableContainer: {
      cursor: 'pointer'
    },
    month: {
      display: 'block',
      color: colors.primary,
      fontSize: 14,
      fontWeight: 700,
      letterSpacing: 0,
      lineHeight: '16px',
      textAlign: 'center',
      textTransform: 'uppercase'
    },
    day: {
      display: 'block',
      color: colors.primary,
      fontSize: 44,
      fontWeight: 700,
      letterSpacing: '-0.27px',
      lineHeight: '50.6px',
      textAlign: 'center'
    },
    time: {
      display: 'block',
      color: colors.primary,
      whiteSpace: 'nowrap',
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: 0,
      lineHeight: '14px',
      textAlign: 'center'
    },
    title: {
      display: 'block',
      color: colors.approxBlack,
      fontSize: 14,
      fontWeight: 700,
      lineHeight: '20px',
      marginTop: '8px',
      textAlign: 'center'
    },
    checkinArea: {
      textAlign: 'center',
      marginTop: '0.5rem'
    },
    joinInText: {
      textAlign: 'center',
      marginTop: '0.5rem',
      fontSize: 12,
      fontFamily: FONT_FAMILY,
      fontWeight: 700
    },
    startedCheckin: {
      borderRadius: 4,
      padding: '2px 8px',
      fontSize: 12,
      fontWeight: 700,
      textAlign: 'center',
      color: '#111',
      backgroundColor: colors.continueYellow
    },
    completedCheckin: {
      borderRadius: 4,
      padding: '4px 8px',
      fontSize: 12,
      fontWeight: 700,
      textAlign: 'center',
      color: '#111',
      backgroundColor: colors.completedGreen
    },
    checkin: {
      borderRadius: 4,
      padding: '4px 8px',
      fontSize: 12,
      fontWeight: 700,
      textAlign: 'center',
      color: '#111',
      backgroundColor: colors.continueYellow
    }
  }
  return styles
}

export default themeStyles
